export default "__VITE_ASSET__SrnOszZM__"